import { InputNumber, InputNumberProps } from "antd";
import React from "react";
import { AmountFormat } from "../../../constants/constants";
import { AMOUNT_UTIL } from "../../../utils/amount.utils";
import "./amount-input.scss";

const AmountInput = (props: InputNumberProps) => {
    const format = (value: string | number | undefined) => {
        if (value === undefined || value === "") {
            return "";
        }
        return AMOUNT_UTIL.formatInput(value);
    }

    const parse = (value: string | undefined) => {
        if (!value) return "";
        return value.replace(/\$\s?|(,*)/g, '')
    }


    return (
        <InputNumber
            {...props}
            className="currency-input"
            formatter={value => format(value)}
            parser={value => parse(value)}
            placeholder={props.placeholder || AmountFormat.currencyCharacters}
        />
    )
}


export default AmountInput;